import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Link } from '@react-pdf/renderer';
import LogoWithSlogan from '../../../../assets/images/LogoWithSlogan.png';
import PDFIconHome from '../../Assets/PDFIconHome.png';
import PDFIconMenu from '../../Assets/PDFIconMenu.png';
import PDFIconPinOutline from '../../Assets/PDFIconPinOutline.png';
import { Farm } from 'Context/types';
import { calculatePercentageOfValues, kFormatter } from 'Helpers/helpers';
import ReactPDFChart from 'react-pdf-charts';
import { Area, Bar, CartesianGrid, ComposedChart, Legend, XAxis, YAxis } from 'recharts';

const summary_styles = StyleSheet.create({
  weather_overview_item_container: {
    width: '170px',
    marginBottom: 12,
    padding: 12,
    borderRadius: 16,
    backgroundColor: '#CCEEEA',
    color: '#000000',
    fontSize: 12,
    alignItems: 'center'
  },
  weather_overview_item: { flexDirection: 'row', width: '100%' },
  weather_overview_item_icon: { width: 16, marginRight: 4, padding: 2 }
});
export type SummaryPageProps = {
  left_header: string;
  left_subheader: string;
  center_header: string;
  center_subheader: string;
  week_no: number;
  styles: any;
  total_planned: number;
  total_harvest: number;
  total_forecast: number;
  total_rejects: number;
  graph_data: any[];
};
const SummaryPage = (props: SummaryPageProps) => (
  <View style={props.styles.section} id="overall-farm-report">
    <View
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '0%',
        marginRight: '2%'
      }}
    >
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        }}
      >
        <View
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Text
            style={{
              fontSize: '14px',
              marginBottom: 2,
              textAlign: 'center',
              fontWeight: 'medium'
            }}
          >
            {props.left_header}
          </Text>
          <Text
            style={{
              fontSize: '9px',
              marginBottom: 2,
              textAlign: 'center',
              fontWeight: 400
            }}
          >
            {props.left_subheader}
          </Text>
        </View>
        <View style={{ alignItems: 'center' }}>
          <Text
            style={{
              fontSize: '14px',
              marginBottom: 2,
              textAlign: 'center',
              fontWeight: 'medium'
            }}
          >
            {`${props.center_header}`}
          </Text>
          <Text
            style={{
              fontSize: '11px',
              marginBottom: 2,
              textAlign: 'center',
              fontWeight: 400
            }}
          >
            {props.center_subheader}
          </Text>
        </View>
        <View>
          <Image style={{ width: '90px', padding: '2px' }} src={LogoWithSlogan}></Image>
        </View>
      </View>
    </View>

    <View style={{ flexDirection: 'row', marginTop: 14 }}>
      <View
        style={{
          ...props.styles.info_card,
          backgroundColor: '#7F7F7F80'
        }}
      >
        <Text style={{ fontSize: 16, fontWeight: 'medium', marginBottom: 4 }}>
          {props.total_planned.toLocaleString()}
          {' \u2022'}{' '}
          <Text style={{ fontSize: 12 }}>
            {calculatePercentageOfValues(
              props.total_planned,
              props.total_harvest
            ).toLocaleString() + '%'}
          </Text>
        </Text>
        <Text style={{ fontSize: 13 }}>Planned (Budget)</Text>
      </View>
      <View
        style={{
          ...props.styles.info_card,
          backgroundColor: '#5C5C5CB2'
        }}
      >
        <Text style={{ fontSize: 16, fontWeight: 'medium', marginBottom: 4 }}>
          {props.total_harvest.toLocaleString()}
          {' \u2022'} <Text style={{ fontSize: 12 }}></Text>
        </Text>
        <Text style={{ fontSize: 13 }}>Graded (Actual)</Text>
      </View>
      <View
        style={{
          ...props.styles.info_card,
          backgroundColor: '#98C9FF'
        }}
      >
        <Text style={{ fontSize: 16, fontWeight: 'medium', marginBottom: 4 }}>
          {props.total_forecast.toLocaleString()}
          {' \u2022'}{' '}
          <Text style={{ fontSize: 12 }}>
            {calculatePercentageOfValues(
              props.total_forecast,
              props.total_harvest
            ).toLocaleString() + '%'}
          </Text>
        </Text>
        <Text style={{ fontSize: 13 }}>Lima Forecast</Text>
      </View>
      <View
        style={{
          ...props.styles.info_card,
          backgroundColor: '#EDA0A7'
        }}
      >
        <Text style={{ fontSize: 16, fontWeight: 'medium', marginBottom: 4 }}>
          {props.total_rejects.toLocaleString()}
          {' \u2022'}{' '}
          <Text style={{ fontSize: 12 }}>
            {calculatePercentageOfValues(
              props.total_rejects,
              props.total_harvest
            ).toLocaleString() + '%'}
          </Text>
        </Text>
        <Text style={{ fontSize: 13 }}>Rejected Packhouse</Text>
      </View>
    </View>
    <View
      style={{
        marginTop: 40,
        marginLeft: 10,
        left: 0,
        paddingTop: 30,
        paddingBottom: 20,
        backgroundColor: '#ffffff',
        borderRadius: 6
      }}
    >
      <ReactPDFChart style={{ left: -30 }}>
        <ComposedChart
          width={780}
          height={300}
          data={props.graph_data}
          style={{ left: 0 }}
          barGap={0}
          barSize={4}
          margin={{ top: 30 }}
        >
          <CartesianGrid strokeDasharray="0" vertical={false} />
          <XAxis dataKey="name" interval={0} tick={{ fontSize: 9 }} />
          <YAxis
            tickCount={6}
            tickFormatter={(value: string) => value && kFormatter(Number(value), 1)}
            tick={{ fontSize: 9 }}
          />
          <Legend iconType="circle" iconSize={10} width={830} align="left" />
          <Area
            type="monotone"
            dataKey={'Demand'}
            name="Production Plan"
            stroke="#7F7F7F"
            fill="#cccccc"
            strokeWidth={0.5}
            dot={false}
            isAnimationActive={false}
            fillOpacity={0.3}
          />
          <Bar dataKey={'Actuals'} fill={'#626262'} isAnimationActive={false}></Bar>
          <Bar dataKey={'Forecasts'} fill={'#00B8FF'} isAnimationActive={false}></Bar>
        </ComposedChart>
      </ReactPDFChart>
    </View>
  </View>
);

export default SummaryPage;
